import { memo } from "react";
import { GoogleMap, GoogleMapProps, OverlayView, useJsApiLoader } from "@react-google-maps/api";
import { uuid4 } from "@sentry/utils";
import clsx from "clsx";

import { BitTruckSVGIcon } from "components/SVGIcons";
import { darkMapStyle, lightMapStyle } from "constants/google-map";
import { useColorScheme } from "hooks/useColorScheme";
import DirectionsWrapper from "./DirectionsWrapper";

interface IProps extends GoogleMapProps {
  center?: google.maps.LatLng | google.maps.LatLngLiteral;
  points: google.maps.LatLngLiteral[];
  isDirections?: boolean;
}

function CustomMap({ center, points, isDirections = false }: Readonly<IProps>) {
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAP_API_KEY ?? ""
  });
  const { currentIsDark } = useColorScheme();
  const DirectionsService = new google.maps.DirectionsService();

  return isLoaded ? (
    <GoogleMap
      mapContainerClassName="w-full h-full rounded-base"
      center={center}
      zoom={10}
      onLoad={(map) => {
        const bounds = new window.google.maps.LatLngBounds();
        map.fitBounds(bounds);
        if (map && center) map.panTo(center);
      }}
      options={{
        styles: currentIsDark ? darkMapStyle : lightMapStyle,
        fullscreenControl: false,
        streetViewControl: false,
        zoomControlOptions: {
          position: google.maps.ControlPosition.RIGHT_BOTTOM
        },
        scrollwheel: false
      }}>
      {!isDirections ? (
        points
          .map((item) => ({ ...item, id: uuid4() }))
          .map((item) => (
            <OverlayView
              key={item.id}
              position={item}
              mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}>
              <div
                className={clsx(
                  "flex size-20 rounded-full",
                  currentIsDark
                    ? "bg-[#EE7F009C] border border-[#FFAA6D4D] drop-shadow-[0_0px_5px_#FFA235]"
                    : "bg-[#3e76b248] border border-[#3E77B2] drop-shadow-[0_0px_5px_#29A3FD]"
                )}>
                <BitTruckSVGIcon className="w-10 m-auto" />
              </div>
            </OverlayView>
          ))
      ) : (
        <DirectionsWrapper
          origin={points[0]}
          destination={points[1]}
          directionsService={DirectionsService}
        />
      )}
    </GoogleMap>
  ) : (
    <></>
  );
}

export default memo(CustomMap);
